/* eslint flowtype/require-valid-file-annotation: 0 */ // bca disabled this, do not copy paste OR ELSE
/* eslint no-console:0 */
import Csrf from 'app/common/lib/Csrf';
import Pc from 'app/common/lib/Pc';
import urlUtil from 'app/common/lib/urlUtil';

const fineuploaderLoader = () =>
  import(/* webpackChunkName: "FineuploaderLibrary" */ 'app/common/lib/bundle/fineuploader');

export default class ImageUploader {
  constructor(params, allowMultipleFiles = false, inputTitle, acceptFiles = []) {
    this.styleOverrides = {
      overflow: 'visible',
    };
    this.params = params || {};
    this.inputTitle = inputTitle || 'file input';
    this.allowMultipleFiles = allowMultipleFiles;
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#Limiting_accepted_file_types
    this.acceptFiles = acceptFiles.join(',');
  }

  getUploadUrl() {
    return urlUtil.absolutify('/upload-image/');
  }

  onUploaderSubmit = (fileId, image) => {
    if (this.submitCallback) {
      this.submitCallback(fileId, image);
    }
  };

  onUploaderComplete = (fileId, image, data) => {
    if (!data.success && this.errorCallback) {
      this.errorCallback(data, image);
    } else if (data.success && this.successCallback) {
      this.successCallback(fileId, image, data);
    }
  };

  onUploaderError = (fileId, image, reason) => {
    if (this.errorCallback) {
      this.errorCallback({ error: reason }, image);
    }
  };

  onUploaderProgress = (fileId, image, loaded, total) => {
    const percent = Math.round((loaded / total) * 100);
    if (this.progressCallback) {
      this.progressCallback(loaded, total, percent, image);
    }
  };

  enableUploader = (
    button,
    progressCallback,
    successCallback,
    errorCallback,
    uploadSource = 'unknown',
    submitCallback,
  ) => {
    if (progressCallback) {
      this.progressCallback = progressCallback;
    }
    if (successCallback) {
      this.successCallback = successCallback;
    }
    if (errorCallback) {
      this.errorCallback = errorCallback;
    }
    if (submitCallback) {
      this.submitCallback = submitCallback;
    }
    fineuploaderLoader().then(({ default: qq }) => {
      this.uploader = new qq.FineUploaderBasic({
        debug: Pc.DEBUG,
        button,
        dropZoneElements: [button],
        inputTitle: this.inputTitle,
        multiple: this.allowMultipleFiles,
        text: {
          defaultResponseError: 'An unknown upload error occurred.',
        },
        request: {
          endpoint: this.getUploadUrl(),
          inputName: 'img',
          forceMultipart: true,
          customHeaders: {
            'X-CSRFToken': Csrf.getCSRFToken(),
            'X-UPLOAD-SOURCE': uploadSource,
          },
          params: this.params,
        },
        callbacks: {
          onUpload: this.onUploaderSubmit,
          onComplete: this.onUploaderComplete,
          onProgress: this.onUploaderProgress,
          onError: this.onUploaderError,
        },
        validation: {
          acceptFiles: this.acceptFiles || '',
        },
      });

      // for some reason, FineUploader sets some styles...
      if (button) {
        Object.assign(button.style, this.styleOverrides);
      }
    });
  };
}
